<template>
  <div id="index">
    <el-container>
      <div class="rightSide" style="top: 0; left: 0">
        <el-header class="Large-Header">
          <img src="~/assets/img/Loginlogo.png" />
          <span>
            {{ translate["ACIoTSMP"] }}
            <!-- <small>Air Compressor IoT Management Platform</small> -->
          </span>
          <div class="Large-language">
            <el-button @click="changeLanguage('zh')" round
              :class="activeLang == 'zh' ? 'selected' : ''">简体中文</el-button>
            <el-button @click="changeLanguage('en')" round
              :class="activeLang == 'en' ? 'selected' : ''">English</el-button>
            <el-button class="backHome" icon="el-icon-s-home" v-on:click="retHome()" v-if="showBackHomeButton"></el-button>
          </div>
        </el-header>
        <el-main class="index Large-index">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" style="position: relative">
              <el-row>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" style="position: absolute; top: 0; left: 10px; right: 10px">
                  <div class="homeConNoBG" style="overflow: hidden">
                    <div id="map" :style="mapHeight"></div>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="24"
                  style="position: absolute; top: 51vh; left: 10px; right: 10px">
                  <div class="homeConNoBG" style="overflow: hidden">
                    <div id="sankeyMap" :style="sankeyMapHeight"></div>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="7" :lg="7">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity" :style="H1">
                        <h4 class="BoxTitle">
                          {{ translate["projectList"] }}
                          <strong class="fr">{{ stationProjectList.length }}</strong>
                        </h4>
                        <div class="table-container" @mouseenter="stopAutoScroll" @mouseleave="startAutoScroll"
                          :style="H1Table">
                          <div class="table-header">
                            <el-table :data="[]" :empty-text="''" border style="width: 100%">
                              <!-- 表头列定义 -->
                              <el-table-column prop="projectName" :label="$t('title.name')"
                                align="center"></el-table-column>
                              <el-table-column prop="region" :label="$t('desc.region')"
                                align="center"></el-table-column>
                              <el-table-column prop="province" :label="$t('desc.province')"
                                align="center"></el-table-column>
                              <el-table-column prop="city" :label="$t('desc.city')" align="center"></el-table-column>
                              <!-- <el-table-column prop="creationTime" :label="$t('desc.creationTime')" align="center"></el-table-column> -->
                            </el-table>
                          </div>
                          <div class="table-body" ref="tableBody">
                            <el-table :data="stationProjectList" :show-header="false" border @cell-mouse-enter="stopAutoScroll"
                              @cell-mouse-leave="startAutoScroll">
                              <el-table-column prop="projectNameEn" :label="$t('desc.projectName')" align="center">
                                <template slot-scope="scope">
                                  <span class="clickable" @click="navigateToDetail(scope.row)">
                                    {{ activeLang == 'en' ? scope.row.projectNameEn : scope.row.projectName }}
                                  </span>
                                </template>
                              </el-table-column>
                              <el-table-column prop="region" :label="$t('desc.region')" align="center">
                                <template slot-scope="scope">
                                  {{ getTranslatedValue('city', scope.row.region) }}
                                </template>
                              </el-table-column>
                              <el-table-column prop="province" :label="$t('desc.province')" align="center">
                                <template slot-scope="scope">
                                  {{ getTranslatedValue('city', scope.row.province) }}
                                </template>
                              </el-table-column>
                              <el-table-column prop="city" :label="$t('desc.city')" align="center">
                                <template slot-scope="scope">
                                  {{ getTranslatedValue('city', scope.row.city) }}
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity" style="padding: 12px 15px">
                        <h4 class="BoxTitle">
                          {{ translate["electricitySaving"] }}
                          <span class="fr">{{
                            formatNumber(sumSavingElec)
                          }}&nbsp;kWh</span>
                        </h4>
                        <!-- <div id="SavingLine" :style="H5"></div> -->
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity" style="padding: 12px 15px">
                        <h4 class="BoxTitle">
                          {{ translate["sumSavingMoney"] }}
                          <span class="fr">￥&nbsp;{{
                            formatNumber(sumSavingMoney)
                          }}</span>
                        </h4>
                        <!-- <div id="SavingLine" :style="H5"></div> -->
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="6" :lg="6" style="float: right">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["sumFlowByDay"] }}
                          <span class="fr">{{ formatNumber(sumFlowByDay) }} m³/min</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["sumPowerByDay"] }}
                          <span class="fr">{{ formatNumber(sumPowerByDay) }}&nbsp;&nbsp;kW</span>
                        </h4>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["AvgPressureRange"] }}
                          <!-- <strong class="fr">{{ registerRate }}%</strong> -->
                        </h4>
                        <div id="avgPressurePie" :style="H2"></div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="homeCon homeConOpacity">
                        <h4 class="BoxTitle">
                          {{ translate["AvgFlowRange"] }}
                          <!-- <strong class="fr">{{ registerRate }}%</strong> -->
                        </h4>
                        <div id="avgFlowPie" :style="H2"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import * as echarts from "echarts";
import "assets/eCharts/world_new.js";
import {
  getShipmentStat,
  getRegistrationStat,
  getOnlineStat,
  getOfflineStat,
  getBaseStat,
  getWarnStat,
  getTripStat,
  getUtilizationStat,
  getMapStat,
  getInsightStat,
  getScreenDataStat,
  getScreenDevice,

  getStationProjectList,
  getMonitorItemList,
  getAvgPressureRangeData,
  getAvgFlowRangeData,
  getSumFlowByDay,
  getSumPowerByDay,
  getElectricitySaving,
  getProjectMapData,
} from "../../api/api";
import { mapCoordinate } from "../../mixins/mapCoordinate";
import { multiTranslate } from "../../mixins/multiTranslate";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Index",
  ...mapMutations(["setLanguage", "setMultiLanguage"]),
  mixins: [mapCoordinate, multiTranslate],
  data() {
    return {
      translate: {},
      rightH: {
        height: "",
        minHeight: "587px",
      },
      mapHeight: {
        height: "",
        minHeight: "245px",
      },
      sankeyMapHeight: {
        height: "",
        minHeight: "100px",
      },
      H1Table: {
        height: "",
        minHeight: "170px",
        width: "100%",
        borderRadius: "12px",
        overflow: "auto"
      },
      H1: {
        height: "",
        minHeight: "200px",
      },
      H2: {
        height: "",
        minHeight: "130px",
      },
      // H3: {
      //   height: "",
      //   minHeight: "160px",
      // },
      // H3LineHeight: {
      //   lineHeight: "17px",
      // },
      // H4: {
      //   height: "",
      //   minHeight: "200px",
      // },
      H5: {
        height: "",
        minHeight: "120px",
        width: "100%",
        // marginBottom: "0px",
      },
      carouselNum: 4,
      insightStatList: [],
      mapProvinceData: [],
      mapCityData: [],
      totalShipmentCount: 0,
      registerRate: 0,
      onlineRate: 0,
      offlineRate: 0,
      warningCount: 0,
      tripCount: 0,
      utilizationRate: 0,
      tableCustomer: [],
      registTotal: [],
      onlineTotal: [],
      offlineTotal: [],
      TripData: [],
      WarningData: [],
      UtlizationData: [],
      classifyNumObj: {},
      stationProjectList: [], // 原始数据
      intervalId: null,
      scrollSpeed: 50, // 滚动速度，单位 ms
      // monitorItemList: [],
      // avgPressureRangeData: [],
      // avgFlowRangeData: [],
      sumFlowByDay: null,
      sumPowerByDay: null,
      electricitySavingMonthList: null,
      sumSavingMoney: null,
      sumSavingElec: null,
      // flowThrendByProject: [],
      // pressureThrendByProject: [],
      // powerThrendByProject: [],
      // dewPointThrendByProject: [],
      // sumFlowByProject: [],
      // sumPowerByProject: [],
      // avgPressureByProject: [],
      // avgDewPointByProject: [],
      sankeyData: [],
      sankeyLinks: [],
      showBackHomeButton: true
    };
  },
  mounted() {
    //let lang = window.localStorage.getItem("multi_lang");
    let lang = window.localStorage.getItem("user_lang");
    if (!lang || lang == "zh") {
      this.translate = this.multiBrandZH;
      this.activeLang = "zh";
    } else if (lang == "en") {
      this.translate = this.multiBrandEn;
      this.activeLang = "en";
    }
    const rawRoles = localStorage.getItem('roles');
    const roles = rawRoles ? rawRoles.trim().replace(/[^a-zA-Z0-9_]/g, '') : '';
    console.log('roles:', roles);
    if  (roles === "EMCManager") {
      this.showBackHomeButton = false;
    }
    var that = this;
    this.getMapData();
    this.getStationProjectList();
    this.getMonitorItemList();
    this.getAvgPressureRangeData();
    this.getAvgFlowRangeData();
    this.getSumFlowByDay();
    this.getSumPowerByDay();
    this.getElectricitySaving();
    this.getMapData();
    this.SetMapHeight();
    this.$nextTick(() => {
      // that.initMap();
      // that.initSankey();
    });
    window.addEventListener("resize", this.SetMapHeight);
    this.getStationProjectList().then(() => {
      that.startAutoScroll();
    });
  },

  methods: {
    ...mapMutations(["setLanguage", "setMultiLanguage"]),
    changeLanguage(e) {
      //window.localStorage.setItem("multi_lang", e);
      window.localStorage.setItem("user_lang", e);
      this.setLanguage(e);
      window.location.reload();
    },
    getTranslatedValue(namespace, key) {
      // return this.$t(`${namespace}.${key}`);
      return this.$t(`${namespace}.${key}`).indexOf(".") > -1 ? key : this.$t(`${namespace}.${key}`)
    },
    SetMapHeight() {
      var WH = document.documentElement.clientHeight;
      var HTime = parseInt((WH - 290) / 19);
      this.H1.height = HTime * 17 + "px";
      this.H1Table.height = HTime * 17 - 30 + "px";
      this.H2.height = HTime * 7.3 + "px";
      // this.H3.height = HTime * 8 + "px";
      // if ((HTime * 8) / 6 - 16 > 11) {
      //   this.H3LineHeight.lineHeight = (HTime * 8) / 6 - 16 + "px";
      // } else {
      //   this.H3LineHeight.lineHeight = "11px";
      // }
      // this.H4.height = HTime * 10.5 + "px";
      this.H5.height = HTime * 14 - 170 + "px";
      this.mapHeight.height = (WH - 110) * 55 / 100 + "px";
      this.sankeyMapHeight.height = (WH - 110) * 43 / 100 + "px";
      // this.rightH.height = WH - 110 - 61 + "px";
      // this.carouselNum = (WH - 110 - 61) / 145;
    },

    async getStationProjectList() {
      let that = this;
      let res = await getStationProjectList();
      this.stationProjectList = res.result
      // const stationProjectList = res.result
      // this.stationProjectList =[...stationProjectList, ...stationProjectList]
    },

    navigateToDetail(row) {
      const targetUrl = `/OneStationMonitor?id=${row.id}`;
      // const targetUrl = `/OneStationMonitor?id=${row.id}&name=${row.projectName}&nameEn=${row.projectNameEn}&img=${row.stationImgUrl}`;
      // window.location.href = targetUrl;
      window.open(targetUrl, '_blank');
    },

    async getMonitorItemList() {
      let that = this;
      let res = await getMonitorItemList();
      console.log('getMonitorItemList', res);
    },
    async getAvgPressureRangeData() {
      let that = this;
      let res = await getAvgPressureRangeData();
      // console.log('getAvgPressureRangeData',res);

      // 确保数据存在
      if (res && res.result) {
        // 处理数据格式
        const pieData = res.result.map(item => ({
          name: item.rangeType,
          value: item.count,
          min: item.minValue,  // 可选：保留边界值用于提示框显示
          max: item.maxValue
        }));

        // 按压力范围排序（可选）
        pieData.sort((a, b) => a.min - b.min);

        // 初始化图表
        const chart = echarts.init(document.getElementById('avgPressurePie'));
        const rangeLabel = this.$t('desc.Range');
        const countLabel = this.$t('desc.Count');

        // 配置项
        const option = {
          title: {
            text: ' ',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: ({ data }) =>
              `${rangeLabel}: ${data.name}<br>
              ${countLabel}: ${data.value}<br>`,
            // Pressure: ${data.min}-${data.max} bar`,

            backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
            borderColor: "rgba(0,0,0,0)",
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontFamily: "Arial",
            },
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: pieData.map(item => item.name),
            textStyle: { // 设置文字样式
              color: 'gray' // 将文字颜色设置为灰色
            }
          },
          series: [{
            type: 'pie',
            radius: '65%',
            center: ['55%', '55%'],
            data: pieData,
            label: {
              show: true,
              // formatter: '{b}: {c} ({d}%)',
              formatter: '{d}%',
              color: '#ffffff', // 字体颜色
              fontSize: 10,     // 字体大小
              fontWeight: 'bold' // 字体粗细
            }
          }],
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'] // 自定义颜色
        };

        // 应用配置
        chart.setOption(option);

        // 窗口尺寸自适应
        window.addEventListener('resize', () => chart.resize());
      }
    },
    async getAvgFlowRangeData() {
      let that = this;
      let res = await getAvgFlowRangeData();
      console.log('getAvgFlowRangeData', res);
      // 确保数据存在
      if (res && res.result) {
        // 处理数据格式
        const pieData = res.result.map(item => ({
          name: item.rangeType,
          value: item.count,
          min: item.minValue,  // 可选：保留边界值用于提示框显示
          max: item.maxValue
        }));

        // 按压力范围排序（可选）
        pieData.sort((a, b) => a.min - b.min);

        // 初始化图表
        const chart = echarts.init(document.getElementById('avgFlowPie'));
        const rangeLabel = this.$t('desc.Range');
        const countLabel = this.$t('desc.Count');
        // 配置项
        const option = {
          title: {
            text: ' ',
            left: 'center'
          },
          // grid: {
          //   top: 96,
          //   left: 90,
          //   right: 22,
          //   bottom: 60,
          // },
          tooltip: {
            trigger: 'item',
            formatter: ({ data }) =>
              `${rangeLabel}: ${data.name}<br>
              ${countLabel}: ${data.value}<br>`,
            // Pressure: ${data.min}-${data.max} bar`,

            backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
            borderColor: "rgba(0,0,0,0)",
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontFamily: "Arial",
            },
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: pieData.map(item => item.name),
            textStyle: { // 设置文字样式
              color: 'gray' // 将文字颜色设置为灰色
            }
          },
          series: [{
            type: 'pie',
            radius: '65%',
            center: ['55%', '55%'],
            data: pieData,
            label: {
              show: true,
              // formatter: '{b}:\n\n{c} ({d}%)',
              formatter: '{b}:\n\n{d}%',
              color: '#ffffff', // 字体颜色
              fontSize: 10,     // 字体大小
              fontWeight: 'bold' // 字体粗细
            }
          }],
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'] // 自定义颜色
        };

        // 应用配置
        chart.setOption(option);

        // 窗口尺寸自适应
        window.addEventListener('resize', () => chart.resize());
      }
    },
    async getSumFlowByDay() {
      let that = this;
      let res = await getSumFlowByDay();
      console.log('getSumFlowByDay', res);
      this.sumFlowByDay = res.result;
    },
    async getSumPowerByDay() {
      let that = this;
      let res = await getSumPowerByDay();
      console.log('getSumPowerByDay', res);
      this.sumPowerByDay = res.result;
    },
    async getElectricitySaving() {
      let that = this;
      let res = await getElectricitySaving();
      console.log('getElectricitySaving', res);
      this.sumSavingMoney = res.result.sumSavingMoney;
      // this.electricitySavingMonthList = [ { "cycle": "2025-04", "savingValue": 2195303.76, "sumPowerValue": 14072.46 }, { "cycle": "2025-03", "savingValue": 2195003.64, "sumPowerValue": 5231.24 }, { "cycle": "2025-02", "savingValue": 2195203, "sumPowerValue": 0 }, { "cycle": "2025-01", "savingValue": 973010, "sumPowerValue": 0 }, { "cycle": "2024-12", "savingValue": 973010, "sumPowerValue": 0 }, { "cycle": "2024-11", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-10", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-09", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-08", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-07", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-06", "savingValue": 0, "sumPowerValue": 0 }, { "cycle": "2024-05", "savingValue": 0, "sumPowerValue": 0 } ];
      this.sumSavingElec = res.result.sumSavingElec;

      // 暗色主题折线图
      if (this.electricitySavingMonthList?.length) {
        // 时间排序（根据实际数据顺序需要）
        const sortedData = [...this.electricitySavingMonthList].reverse();

        const chart = echarts.init(document.getElementById('SavingLine'));
        const elecSavingTrendByMonth = this.$t('desc.elecSavingTrendByMonth');

        const option = {
          title: {
            text: elecSavingTrendByMonth,
            left: 'center',
            textStyle: {
              color: '#ddd', // 标题颜色
              fontSize: 12,
              fontWeight: 300
            }
          },
          grid: {
            top: 56,
            left: 60,
            right: 12,
            bottom: 50,
          },
          xAxis: {
            type: 'category',
            data: sortedData.map(d => d.cycle),
            axisLabel: {
              color: '#ccc', // X轴标签颜色
              rotate: 45, // 标签旋转角度
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                color: '#666' // X轴线颜色
              }
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
          },
          yAxis: {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
              color: '#ccc' // 单位颜色
            },
            axisLabel: {
              color: '#828393',
              formatter: '{value}', // 单位显示
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            splitLine: {
              lineStyle: {
                color: '#3A3D46' // 网格线颜色
              }
            }
          },
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100,
            xAxisIndex: 0,
            filterMode: 'filter'
          }],
          tooltip: {
            trigger: 'axis',
            // axisPointer: {
            //   type: 'cross',
            //   crossStyle: {
            //     color: '#fff'
            //   }
            // },
            backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
            borderColor: "rgba(0,0,0,0)",
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontFamily: "Arial",
            },
            formatter: params => {
              const data = params[0];
              return `${data.name}<br>
                ${data.data} kWh`;
            }
          },
          series: [{
            data: sortedData.map(item => item.savingValue.toFixed(2)),
            type: 'line',
            smooth: true,
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            lineStyle: {
              color: "rgba(255,255,255,1)", // 折线颜色
              width: 2, // 折线宽度
              type: 'solid', // 折线类型（solid、dashed、dotted）
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(62,96,149,0.5)" },
                  { offset: 1, color: "rgba(62,96,149,0)" },
                ]),
              },
            },
            // emphasis: {
            //   itemStyle: {
            //     color: '#00bfff', // 高亮颜色
            //     borderColor: '#fff',
            //     symbolSize: 12
            //   }
            // }
          }],
          // dataZoom: [{
          //   type: 'slider',
          //   show: true,
          //   start: 0,
          //   end: 100,
          //   backgroundColor: '#333', // 数据区域缩放背景
          //   dataBackground: {
          //     lineStyle: { color: '#666' },
          //     areaStyle: { color: '#444' }
          //   }
          // }]
        };

        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      }
    },

    retHome() {
      //this.$router.push({ path: "/index" });      
      window.location.href = "/index";
    },

    initSankey(sankeyData, sankeyLinks) {
      let that = this;
      var chart = echarts.init(document.getElementById("sankeyMap"));
      var mWidth = document.documentElement.clientWidth;
      var mHeight = document.documentElement.clientHeight;
      const option = {
        backgroundColor: '#1f2128', // 深灰色背景
        title: {
          subtext: '',
          left: 'center'
        },
        series: [
          {
            type: 'sankey',
            // roam: true, // 启用拖拽和平移
            draggable: false,
            layoutIterations: 0,
            left: mWidth * 7 / 24,
            top: 0.0,
            right: mWidth * 7 / 24,
            bottom: 40.0,
            data: sankeyData,
            links: sankeyLinks,
            levels: [
              { depth: 0, height: 0.1, itemStyle: { opacity: 0.9 }}, // 第0层（如"中国"）高度占比10%
              { 
                depth: 1, 
                height: 0.3, // 第1层高度占比30%
                nodeAlign: 'left', // 可选: 'left', 'right', 'justify'
                nodeGap: 30,      // 增大该层节点间距
                itemStyle: { opacity: 0.8 }
              },
              { 
                depth: 2,
                nodeAlign: 'left', // 可选: 'left', 'right', 'justify'
                nodeGap: 50,      // 增大该层节点间距
                height: 0.5,       // 第2层高度占比50%
                itemStyle: { opacity: 0.7 }
              },
              { 
                depth: 3,
                nodeAlign: 'right', // 可选: 'left', 'right', 'justify'
                nodeGap: 50,      // 增大该层节点间距
                height: 1,       // 第2层高度占比50%
                itemStyle: { opacity: 0.5 }
              },
            ],
            lineStyle: {
              // color: 'source',
              color: 'gradient',
              opacity: 0.1,
              curveness: 0.5
            },
            label: {
              // 关键配置：自定义标签内容
              formatter: (params) => {
                const name = that.translateResourceType(params.name);
                return `${name}: ${params.value}`;
              },
              color: 'rgba(255,255,255,0.7)',
              fontFamily: 'Arial',
              fontSize: 10
            }
          }
        ],
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            // 判断是否为连线数据
            if (params.componentType === 'series' && params.seriesType === 'sankey' && params.dataType === 'edge') {
              const from = that.translateResourceType(params.data.source);
              const to = that.translateResourceType(params.data.target);
              return `${from}→${to}: ${params.value}`;
            }
            const name = that.translateResourceType(params.name);
            return `${name}: ${params.value}`;
          },
          backgroundColor: 'rgba(0,0,0,0.7)',
          textStyle: {
            color: '#fff'
          }
        }
      };

      chart.setOption(option, { notMerge: true });
      // window.addEventListener('resize', () => chart.resize());
      window.addEventListener('resize', () => chart.resize());
    },
    /**
     * 生成随机颜色（十六进制格式）
     */
    getRandomColor() {
      return `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0')}`;
    },

    /**
     * 转换数据为桑基图格式
     * @param {Array} regionData 原始区域数据
     * @returns {Object} { nodes: [], links: [] }
     */
    convertToSankeyData(regionData) {
      const nodes = [];
      const links = [];
      const nodeMap = new Map(); // 避免重复节点
      const MUNICIPALITIES = ['北京', '上海', '天津', '重庆'];
      let that = this

      // 1. 添加根节点"中国"
      const rootNode = {
        name: '中国',
        itemStyle: {
          color: '#4E79A7', // 固定根节点颜色
          borderColor: '#4E79A7'
        }
      };
      nodes.push(rootNode);
      nodeMap.set('中国', rootNode);

      // 2. 遍历区域数据
      regionData.forEach(region => {
        // 添加区域节点
        if (!nodeMap.has(region.name)) {
          const randomColor = that.getRandomColor()
          const regionNode = {
            name: region.name,
            itemStyle: {
              color: randomColor,
              borderColor: randomColor
            }
          };
          nodes.push(regionNode);
          nodeMap.set(region.name, regionNode);

          // 添加中国→区域的链接
          links.push({
            source: '中国',
            target: region.name,
            value: region.value
          });
        }

        // 3. 遍历省份数据
        region.list?.forEach(province => {
          if (!nodeMap.has(province.name)) {
            const randomColor = that.getRandomColor()
            const provinceNode = {
              name: province.name,
              itemStyle: {
                color: randomColor,
                borderColor: randomColor
              }
            };
            if (MUNICIPALITIES.includes(province.name)) {
              provinceNode.depth = 2
            }
            nodes.push(provinceNode);
            nodeMap.set(province.name, provinceNode);

            // 添加区域→省份的链接
            links.push({
              source: region.name,
              target: province.name,
              value: province.value
            });
          }

          // 4. 遍历城市数据
          province.list?.forEach(city => {
            if (!nodeMap.has(city.name)) {
              const randomColor = that.getRandomColor()
              const cityNode = {
                name: city.name,
                itemStyle: {
                  color: randomColor,
                  borderColor: randomColor
                }
              };
              nodes.push(cityNode);
              nodeMap.set(city.name, cityNode);

              // 添加省份→城市的链接
              links.push({
                source: province.name,
                target: city.name,
                value: city.value
              });
            }
          });
        });
      });
      that.sankeyData = nodes;
      that.sankeyLinks = links;
    },


    async getMapData() {
      let that = this;
      let res = await getProjectMapData();
      console.log('getProjectMapData', res.result);
      const mapRegionData = res.result;
      that.mapProvinceData = [];
      that.mapCityData = [];
      if (
        mapRegionData != "" &&
        mapRegionData != undefined &&
        mapRegionData != null
      ) {
        //处理地图数据
        mapRegionData.forEach(function (region) {
          if (
            region.list != "" &&
            region.list != undefined &&
            region.list != null
          ) {
            region.list.forEach(function (province) {
              if (province != "" && province != undefined && province != null) {
                const filteredProvince = {
                  "name": province.name,
                  "value": []
                }
                province.list.forEach(function (city) {
                  const { type, list, ...filteredCity } = city; // 解构并过滤掉 type 和 list
                  that.mapCityData.push(filteredCity); // 只保留其他字段
                  filteredProvince.value.push(filteredCity)
                });
                that.mapProvinceData.push(filteredProvince); // 只保留其他字段
              }
            });
          }
        })

        //处理能流图数据,赋值全局的sankeyData和sankeyLinks
        that.convertToSankeyData(mapRegionData)
        that.initSankey(this.sankeyData, this.sankeyLinks);
      }
      that.initMap();
    },

    initMap() {
      // 获取echarts的容器
      let that = this;
      var chart = echarts.init(document.getElementById("map"));
      var geoCoordMap = JSON.parse(JSON.stringify(this.mapCoordinate));
      var ProvinceData = this.mapProvinceData; //省级标点数据
      var CityData = this.mapCityData; //市级标点数据

      // var Singaporetemp = {
      //   //亚太的数据格式（省级）
      //   name: "New Zealand",
      //   value: [
      //     {
      //       name: "New Zealand",
      //       value: 10,
      //     },
      //   ],
      // };
      // var Philippinestemp = {
      //   //亚太的数据格式（市级）
      //   name: "Philippines",
      //   value: 0,
      // };

      // ProvinceData.push(Singaporetemp);
      // CityData.push(Philippinestemp);

      var ProvinceName = [
        "河北",
        "山西",
        "辽宁",
        "吉林",
        "黑龙江",
        "江苏",
        "浙江",
        "安徽",
        "福建",
        "江西",
        "山东",
        "河南",
        "湖北",
        "湖南",
        "广东",
        "海南",
        "四川",
        "贵州",
        "云南",
        "陕西",
        "甘肃",
        "青海",
        "中国台湾",
        "内蒙古",
        "广西",
        "宁夏",
        "西藏",
        "新疆",
        "北京",
        "天津",
        "上海",
        "重庆",
        "香港",
        "澳门"
      ];

      var regions = [
        //对不同的区块进行着色
        {
          name: "China",
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        }
      ];
      ProvinceName.forEach(function (item) {
        var temp = {
          name: that.translateResourceType(item),
          itemStyle: {
            areaColor: "rgba(40, 115, 154, 1)",
          },
        };
        regions.push(temp);
      });

      var ProvinceSeries = [];
      var CitySeries = [];

      function ProvinceFunciton(data) {
        var temp = [];
        [[, data]].forEach(function (item, i) {
          temp.push({
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              //涟漪特效
              period: 2, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 3.5,
              //波纹圆环最大限制，值越大波纹越大
              color: "rgba(255,255,255,0.8)",
            },
            itemStyle: {
              color: "rgba(255,255,255,1)",
              borderColor: "rgba(255,242,77, 0.8)",
            },
            label: {
              normal: {
                show: true,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: "", //圆环显示文字
              },
              emphasis: {
                show: true,
              },
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              if (val != "" && val != undefined && val != null) {
                var value = val.slice(2, val.length);
                let total = value.reduce((x, y) => {
                  return (x += y.value);
                }, 0);

                var state = Math.floor(total / 150);
                if (state < 10) {
                  level = state;
                } else {
                  level = 10;
                }
              }
              return level + 3; //圆环大小
            },

            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name /*+"\n"+dataItem[0].value*/,
                value:
                  geoCoordMap[dataItem.name] == null
                    ? ""
                    : geoCoordMap[dataItem.name].concat(dataItem.value),
              };
            }),
            tooltip: {
              show: true,
              showDelay: 0,
              hideDelay: 500,
              formatter: function (params, ticket, callback) {
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                var value = params.value.slice(2, params.value.length);
                let total = value.reduce((x, y) => {
                  return (x += y.value);
                }, 0);
                res =
                  "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;margin-bottom:8px'>" +
                  that.translateResourceType(name) +
                  ": " +
                  total +
                  "</h5>";
                for (let index = 0; index < value.length; index++) {
                  const element = value[index];
                  if (element.name == params.name) {
                  } else {
                    res += that.translateResourceType(element.name) + " : " + element.value + "<br>";
                  }
                }
                return res;
                res += "</div>";
              },
            },
          });
        });
        return temp;
      }
      //var series = [];
      function CityFunciton(data) {
        var temp = [];
        [[, data]].forEach(function (item, i) {
          temp.push({
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 4,
            rippleEffect: {
              //涟漪特效
              period: 2, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 2.5,
              //波纹圆环最大限制，值越大波纹越大
              color: "rgba(255,255,255,0.8)",
            },
            itemStyle: {
              color: "rgba(255,255,255,1)",
              borderColor: "rgba(255,242,77, 0.8)",
            },
            label: {
              normal: {
                show: true,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: "", //圆环显示文字
              },
              emphasis: {
                show: true,
              },
            },
            symbol: "circle",
            symbolSize: function (val) {
              var level = 0;
              if (val != "" && val != undefined && val != null) {
                var state = Math.floor(val[2] / 50);
                if (state < 10) {
                  level = state;
                } else {
                  level = 10;
                }
              }
              return level + 4; //圆环大小
            },

            data: item[1].map(function (dataItem) {
              return {
                name: dataItem.name /*+"\n"+dataItem[0].value*/,
                value:
                  geoCoordMap[dataItem.name] == null
                    ? ""
                    : geoCoordMap[dataItem.name].concat(dataItem.value),
              };
            }),
            tooltip: {
              show: true,
              showDelay: 0,
              hideDelay: 0,
              formatter: function (params, ticket, callback) {
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                var value = params.value[2];

                res =
                  "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;'>" +
                  that.translateResourceType(name) +
                  " : " +
                  value +
                  "</h5>";

                res += "</div>";
                return res;
              },
            },
          });
        });
        return temp;
      }

      var mWidth = document.documentElement.clientWidth;
      var mHeight = document.documentElement.clientHeight;
      // var step = 37 + ((mHeight / mWidth) * 100 - 56);
      var mleft = "";
      var mtop = "";

      //mleft = -8 - (mHeight - 657) / 10 - 1 + "%";
      mleft = -(74 - ((mWidth / mHeight) * 72) / 1.98) + "%";
      //mleft = "-35%";
      mtop = "105%";

      var option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.8)",
          borderColor: "rgba(255,255,255,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
          showDelay: 0,
          hideDelay: 500,
          enterable: true,
          transitionDuration: 0,
          extraCssText: "z-index:100",
          confine: true,
          renderMode: "html",
          formatter: function (params, ticket, callback) {
            //根据业务自己拓展要显示的内容
            var res = "";
            var name = params.name;
            var value = params.value.slice(2, params.value.length);
            let total = value.reduce((x, y) => {
              return (x += y.value);
            }, 0);
            res =
              "<div style='padding-right:12px;color:#fff;max-height:260px;overflow:auto;display:block;line-height: 22px;'><h5 style='margin:0;font-weight:bold;font-size:14px;margin-bottom:8px'>" +
              that.translateResourceType(name) +
              ": " +
              total +
              "</h5>";
            for (let index = 0; index < value.length; index++) {
              const element = value[index];
              res += that.translateResourceType(element.name) + " : " + element.value + "<br>";
            }
            res += "</div>";
            return res;
          },
        },
        // visualMap: {
        //   //图例值控制
        //   min: 0,
        //   max: 10000,
        //   text: ["High", "Low"],
        //   show: false,
        //   calculable: true,
        //   //color: ["#0bc7f3"],
        //   color: ["orangered", "yellow", "lightskyblue"],
        // },
        geo: {
          map: "world",
          label: {
            emphasis: {
              show: true,
              color: "rgba(255,255,255,0.5)",
            },
            formatter: function (params, ticket, callback) {
              //根据业务自己拓展要显示的内容
              var res = that.translateResourceType(params.name);
              return res;
            },
          },
          roam: true, //是否允许缩放
          zoom: 7,
          layoutCenter: [mleft, mtop], //地图位置
          layoutSize: "100%",
          itemStyle: {
            areaColor: "rgba(41,111,203,0 )",
            borderColor: "#7CC9F0",
            emphasis: {
              color: "#212733", //悬浮背景
            },
          },
          regions: regions,
          tooltip: {
            show: false,
          },
        },
        series: ProvinceFunciton(ProvinceData),
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
      chart.on("georoam", function (params) {
        var zoom = chart.getOption().geo[0].zoom;

        if (zoom > 12) {
          var temp = {
            series: CityFunciton(CityData),
          };
          chart.setOption(temp);
        } else {
          var temp = {
            series: ProvinceFunciton(ProvinceData),
          };
          chart.setOption(temp);
        }
      });
    },
    translateResourceType(name) {
      return this.$t('city.' + name).indexOf(".") > -1 ? name : this.$t('city.' + name)
    },

    startAutoScroll() {
      if (this.intervalId) return;
      const body = this.$refs.tableBody;
      // console.log(body.clientHeight);
      // console.log(body.scrollHeight);
      this.intervalId = setInterval(() => {
        if (body.scrollTop + body.clientHeight >= body.scrollHeight - 2) {
          this.stopAutoScroll()
          setTimeout(() => {
            body.scrollTop = 0; // 回到顶部，视觉上无缝
            this.startAutoScroll()
          }, 400);
        } else {
          body.scrollTop += 1;
        }
      }, this.scrollSpeed);
    },
    stopAutoScroll() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },

    formatNumber(num) {
      if (!num) return num;
      const numStr = num.toString();
      const [integerPart, decimalPart] = numStr.split('.');
      if (integerPart.length > 3) {
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formattedInteger;
      }
      // 处理不超过3位整数的情况
      return decimalPart ? numStr : num.toFixed(2);
    }
  },
};
</script>

<style lang="less" scope>
body {
  padding: 0;
  margin: 0;
  color: #fff;
}

.theme1 {
  .backHome {
    width: auto !important;
    //   height: 26px !important;
    padding: 0px 10px !important;
    font-size: 12px !important;
    //  //  line-height: 27px;
    //margin-top: 31px;
    // margin-left: 29px;
    background: rgba(255, 255, 255, 0.3) !important;

    i {
      color: #fff;
      margin-right: 5px;
    }

    span {
      margin: 0 !important;
      font-size: 13px !important;
      line-height: 25px !important;
      padding: 0;
      color: #fff;
    }
  }

  // .rightSide {
  //   top: 0;
  //   left: 0;
  // }

  .Large-Header {
    text-align: center;
    height: 90px !important;
    z-index: 2;

    img {
      height: 46px;
      margin: 16px 0 0 30px;
      float: left;
    }

    span {
      display: inline-block;
      font-size: 24px;
      font-weight: 600;
      margin-top: 15px;
      line-height: 45px;
      margin-left: -192px;
      margin-right: -258px;

      small {
        display: block;
        font-size: 12px;
        margin: 0;
        line-height: 14px;
        color: #828393;
      }
    }
  }

  .Large-index {
    padding-top: 90px !important;
  }

  .el-row {
    margin-left: -10px !important;
    margin-right: -10px !important;
  }

  .el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .el-table--small {

    td,
    th {
      padding: 9px 2px;
    }
  }

  .el-table {
    .el-table__body {
      tr {
        td {
          border-radius: 0 !important;
          background-color: rgba(0, 0, 0, 0);
        }
      }
    }

    tr {
      border-radius: 0 !important;
      background-color: rgba(0, 0, 0, 0);
    }

    .cell {
      padding: 0 0px;
    }

    .strong {
      .cell {
        color: #fff;
        font-weight: bold;
      }
    }
  }

  // 客户列表样式
  .homeCon {
    padding: 12px 15px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    /* 确保表格内容可以滚动 */
  }

  .clickable {
    cursor: pointer;
    text-decoration: none;
    /* 默认无下划线 */
  }

  .clickable:hover {
    text-decoration: underline;
    /* 鼠标悬浮时加下划线 */
  }

  .InstallTotal {
    position: absolute;
    bottom: 12px;
    right: 20px;
    left: 20px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;

    li {
      line-height: 14px;
      padding: 8px 0;

      span.name {
        display: inline-block;
        font-weight: bold;
        color: #fff;
        width: calc(100% - 120px);
      }

      span.num {
        display: inline-block;
        color: #fff;
        width: 120px;
        text-align: right;

        small {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          margin: 0 5px;
        }
      }
    }
  }

  .HealthRateUl {
    margin: 0;
  }

  .rightsideDiv {
    border-left: 0;
  }

  .homeConNoBG {
    padding-left: 0px;
  }

  .Large-language {
    float: right;
    margin-top: 22px;

    .el-button {
      height: 22px;
      border: 0px;
      width: 74px;
      padding: 0;
      background: none;

      span {
        line-height: 20px;
        font-size: 12px;
        margin: 0;
      }
    }

    .el-button.selected {
      background-color: #00759b;

      span {
        color: #fff;
      }
    }
  }

  .homeConOpacity {
    background-color: rgba(36, 39, 49, 0.9);

  }

  .table-container {
    position: relative;

  }

  .table-header {
    background: #2f333b;
  }

  .table-body {
    /* 表头高度 */
    height: calc(100% - 42px);
    overflow-y: auto;
    scrollbar-width: none;
    /* 隐藏原生滚动条 */
    -ms-overflow-style: none;
    /* IE/Edge 隐藏滚动条 */
  }

  .table-body::-webkit-scrollbar {
    display: none;
    /* Chrome/Safari 隐藏滚动条 */
  }

  /* 隐藏空数据区域（不占行高） */
  .el-table__empty-block {
    display: none !important;
  }

  /* 可选：防止表格底部留白 */
  .el-table__body {
    height: auto !important;
  }

  .table-container {
    position: relative;
    z-index: 1; /* 确保在最上层 */
  }
  .table-body, .table-header {
    pointer-events: auto; /* 显式启用事件 */
  }

}
</style>
